export default __webpack_public_path__ + "static/media/PES.016510bd.png";